/*
 * @Date: 2025-05-21 10:25:11
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-05-21 10:26:18
 */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const DynamicTitle = () => {
  const location = useLocation();

  // 基于路由变化来设置标题
  useEffect(() => {
    // 根据当前路径或其他信息设置标题
    const pageTitle = getPageTitle(location.pathname);
    document.title = pageTitle; // 更新页面标题
  }, [location]);

  // 根据路由路径返回对应的标题
  const getPageTitle = (path) => {
    switch (path) {
      case "/":
        return "MC2";
      case "/about":
        return "About Us";
      case "/events":
        return "MC2 - Events";
      case "/read":
        return "MC2 - Read";
      case "/watch":
        return "MC2 - Watch";
      default:
        return "MC2";
    }
  };

  return (
    <Helmet>
      <title>{getPageTitle(location.pathname)}</title>
    </Helmet>
  );
};

export default DynamicTitle;
